import { ReactNode } from "react";

interface AuthLayoutProps {
  children: ReactNode;
  className?: string;
}

export function AuthLayout({ children, className = "" }: AuthLayoutProps) {
  return (
    <div className={`min-h-screen bg-[#1A1A1A] flex items-center justify-center p-4 ${className}`}>
      {children}
    </div>
  );
}
